import { render } from "./InspectionCamera.vue?vue&type=template&id=70d0313d"
import script from "./InspectionCamera.vue?vue&type=script&lang=js"
export * from "./InspectionCamera.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__